<template>
  <section id="risk-reversal" class="py-16 md:py-24 bg-base-200">
    <div class="max-w-screen-xl mx-auto px-4">
      <!-- Clean section header -->
      <div class="text-center mb-16">
        <h2 class="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-base-content">
          {{ $t("riskReversal.heading") }}
        </h2>
        <div class="divider divider-primary w-32 mx-auto mt-6"></div>
        <p class="text-lg text-base-content/80 max-w-2xl mx-auto mt-4">
          {{ $t("riskReversal.subtitle") }}
        </p>
      </div>

      <!-- Guarantee Cards -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Guarantee card 1 -->
        <div class="card bg-base-100 shadow-lg hover:shadow-xl transition-shadow text-center">
          <div class="card-body">
            <!-- Icon -->
            <div class="w-16 h-16 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <LucideShield class="w-8 h-8 text-success" />
            </div>

            <!-- Title -->
            <h3 class="text-xl font-bold mb-3 text-base-content">
              {{ $t("riskReversal.guarantee.title") }}
            </h3>

            <!-- Description -->
            <p class="text-base-content/80">
              {{ $t("riskReversal.guarantee.description") }}
            </p>
          </div>
        </div>

        <!-- Guarantee card 2 -->
        <div class="card bg-base-100 shadow-lg hover:shadow-xl transition-shadow text-center">
          <div class="card-body">
            <!-- Icon -->
            <div class="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <LucideRocket class="w-8 h-8 text-primary" />
            </div>

            <!-- Title -->
            <h3 class="text-xl font-bold mb-3 text-base-content">
              {{ $t("riskReversal.launch.title") }}
            </h3>

            <!-- Description -->
            <p class="text-base-content/80">
              {{ $t("riskReversal.launch.description") }}
            </p>
          </div>
        </div>

        <!-- Guarantee card 3 -->
        <div class="card bg-base-100 shadow-lg hover:shadow-xl transition-shadow text-center">
          <div class="card-body">
            <!-- Icon -->
            <div class="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <LucideHeadphones class="w-8 h-8 text-secondary" />
            </div>

            <!-- Title -->
            <h3 class="text-xl font-bold mb-3 text-base-content">
              {{ $t("riskReversal.support.title") }}
            </h3>

            <!-- Description -->
            <p class="text-base-content/80">
              {{ $t("riskReversal.support.description") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { LucideShield, LucideRocket, LucideHeadphones } from "lucide-vue-next";
</script>